export default __webpack_public_path__ + "static/media/josh.f4ff276e.png";